import { getOrientationFromPageSize, type PageOrientation } from 'components/editor/shared/gridConfig';
import { useEffectivePageSize } from './useEffectivePageSize';

// Orientation is always derived from the effective page size.
export function useEffectiveOrientation(): PageOrientation {
  return getOrientationFromPageSize(useEffectivePageSize());
}
